import * as React from 'react'
import StarRating from './StarRating'

const RadioGroup = ({ question, value, onChange }) => (
  <div className="options">
    {question.options.map((option) => (
      <label key={option} className="option">
        <input
          type="radio"
          name={question.code}
          value={option}
          checked={value === option}
          onChange={() => onChange(option)}
        />
        <span>{option}</span>
      </label>
    ))}
  </div>
)

const CheckboxGroup = ({ question, value, onChange }) => {
  const selected = value || []

  const toggle = (option) => {
    onChange(
      selected.includes(option)
        ? selected.filter((item) => item !== option)
        : [...selected, option]
    )
  }

  return (
    <div className="options">
      {question.options.map((option) => (
        <label key={option} className="option">
          <input
            type="checkbox"
            value={option}
            checked={selected.includes(option)}
            onChange={() => toggle(option)}
          />
          <span>{option}</span>
        </label>
      ))}
    </div>
  )
}

const Question = ({ question, scale, value, error, onChange }) => (
  <div className={`question ${error ? 'has-error' : ''}`} id={`question-${question.code}`}>
    <p className="question-label">
      {question.label}
      {question.required && <span className="required-mark"> *</span>}
    </p>
    {question.description && <p className="question-description">{question.description}</p>}

    {question.type === 'rating' && (
      <StarRating scale={scale} value={value} onChange={onChange} />
    )}
    {question.type === 'radio' && (
      <RadioGroup question={question} value={value} onChange={onChange} />
    )}
    {question.type === 'checkbox' && (
      <CheckboxGroup question={question} value={value} onChange={onChange} />
    )}
    {question.type === 'text' && (
      <textarea
        className="form-control"
        rows="4"
        placeholder={question.placeholder || ''}
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
      />
    )}

    {error && <p className="question-error">{error}</p>}
  </div>
)

export default Question
